// team repository

import http from '../services/http'
import auth from '../services/auth'

export default {
  fetchTeam: function () {
    // fetch the currently logged in user's team
    // if multiple teams are returned, we use the first one
    // switching teams is not yet supported
    return http.get(`/team/`, auth.getAuthHeader(), undefined, true)
    .then((teams) => {
      // if no teams are present, return null, which will
      // trigger 403s down the road
      // FIXME: handle this more cleanly
      if (!teams.length) {
        return null
      }
      return teams[0]
    })
  }
}
